export const DEFAULT_RANK = "m";
